import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm, reset } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import configurationContext from "contextConfig";
import { useContext } from 'react';
import { SUBADMIN } from 'constants.js';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE } from "constants.js";
import Multiselect from 'multiselect-react-dropdown';

function Subadmin() {
    const MyContext = useContext(configurationContext);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const [isLoading, setIsLoading] = useState(false);
    const subadminId = useParams().subadminId;
    const [rolesList, setRolesList] = useState([]);
    const [status, setStatus] = useState(1);
    const adminType = localStorage.getItem("type");
    const [selectedOptions, setSelectedOptions] = useState([]);

    const { register, handleSubmit, setValue, setError, formState: { errors }, reset: resetForm } = useForm();

    const onSelectCustomField = (selectedList, selectedItem) => {
        setSelectedOptions(selectedList);
    };

    const onRemoveCustomfield = (selectedList, removedItem) => {
        setSelectedOptions(selectedList);
    };

    const fetchData = async () => {
        setIsLoading(true)
        await axios.get(BASE + "api/subadmin/view/" + subadminId, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            },
        })
            .then((response) => {
                setIsLoading(false);
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    const responseData = response.data.data;
                    if (status == 1) {
                        setValue('name', responseData.info.name);
                        setValue('email', responseData.info.email);
                        setStatus(responseData.info.status);
                        const transformedArray = (responseData.roles).map(item => ({
                            id: item.id,
                            name: item.name
                        }));
                        setRolesList(transformedArray)
                        const selectedNames = (responseData.info.roles).map(roleId => {
                            const role = (responseData.roles).find(item => item.id === roleId);
                            return role ? { id: role.id, name: role.name } : null;
                        });
                        setSelectedOptions(selectedNames)
                    }
                    else {
                      toast.error(t(message));
                      const redirectTimeout = setTimeout(() => {
                        clearTimeout(redirectTimeout);
                        navigate(`/subadmin/manage/`);
                    }, 2000);
                    }
                  }
                  else {
                    toast.error(t('unableToProccessRequest'));
                    const redirectTimeout = setTimeout(() => {
                        clearTimeout(redirectTimeout);
                        navigate(`/subadmin/manage/`);
                    }, 2000);
                  }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    const getRoles = async () => {
        setIsLoading(true)
        await axios.get(BASE + 'api/role/listAll', {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        })
            .then((response) => {
                setIsLoading(false);
                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        const responseData = response.data.data;
                        const transformedArray = responseData.map(item => ({
                            id: item.id,
                            name: item.name
                        }));
                        setRolesList(transformedArray);
                    }
                    else {
                        toast.error(t(message));
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate(`/subadmin/manage/`);
                        }, 2000);
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                    const redirectTimeout = setTimeout(() => {
                        clearTimeout(redirectTimeout);
                        navigate(`/subadmin/manage/`);
                    }, 2000);
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    useEffect(() => {
        if (subadminId)
            fetchData();
        else {
            getRoles();
            setSelectedOptions([]);
            setStatus(1)
            resetForm();
        }
    }, [subadminId, resetForm]);


    const onSubmit = async (data) => {
        let inputData = {};
        inputData.name = data['name'];
        inputData.email = data['email'];
        inputData.password = data['password'];
        if (subadminId) {
            inputData.id = subadminId;
        }
        inputData.status = status.toString();
        const selectedRoles = (selectedOptions).map(item => (
            item.id
        ));
        inputData.roles = selectedRoles;
        setIsLoading(true);
        axios.post(BASE + 'api/subadmin/save', inputData, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        })
            .then((response) => {
                setIsLoading(false)
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        toast.success(t(message))
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate(`/subadmin/manage/`);
                        }, 2000);
                    }
                    else {
                        if (message != '')
                            toast.error(t(message))
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };
    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={subadminId ? t('edit sub admin') : t('Add sub admin')} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <MDBox pt={6} pb={3} >
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                                <MDBox px={3}>
                                    <Grid container spacing={2} mt={5}>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('name')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <MDInput
                                                type="text"
                                                name="name"
                                                placeholder={t('Enter sub admin name')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("name", {
                                                    required: {
                                                        value: true,
                                                        message: t('Name is madatory')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.name && (<span className="errorMsg FloatRight">{errors.name.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('Email')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <MDInput
                                                type="email"
                                                name="email"
                                                placeholder={t('Enter sub admin email')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("email", {
                                                    required: {
                                                        value: true,
                                                        pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                                        message: t('Email is madatory')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.email && (<span className="errorMsg FloatRight">{t(errors.email.message)}</span>)}
                                        </Grid>
                                        {(subadminId) ?
                                            <>
                                                <Grid item xs={12} sm={3} md={3}>
                                                    <MDTypography variant="body1" className="labelStyle">{t('Password')}</MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={7} md={7}>
                                                    <MDInput
                                                        type="password"
                                                        name="password"
                                                        placeholder={t('Enter sub admin password')}
                                                        InputProps={{
                                                            classes: { root: "inputBoxStyle" },
                                                        }}
                                                        {...register("password", (subadminId == '') ? {
                                                            required: {
                                                                value: true,

                                                                message: t('Password is madatory')
                                                            }
                                                        } : {}
                                                        )}
                                                        onChange={((e) => { e.stopPropagation() })}
                                                        fullWidth />
                                                    {errors.password && (<span className="errorMsg FloatRight">{t(errors.password.message, { length: MyContext.minPasswordLength })}</span>)}
                                                </Grid>
                                            </>
                                            : null}
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('Roles')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <Multiselect
                                                options={rolesList}
                                                selectedValues={selectedOptions}
                                                onSelect={onSelectCustomField}
                                                onRemove={onRemoveCustomfield}
                                                displayValue="name"
                                                name="roles"
                                                className="MultiSelectStyle"
                                                {...register("roles", {
                                                    required: {
                                                        value: (!(selectedOptions?.length > 0)),
                                                        message: t('subAdminRolesRequired')
                                                    }
                                                })}
                                            />
                                            {errors.roles && (<span className="errorMsg FloatRight">{t(errors.roles.message)}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('status')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <Select
                                                id="status"
                                                value={status}
                                                onChange={handleStatusChange}
                                                className="MultiSelectDW"
                                            >
                                                <MenuItem value={SUBADMIN.ACTIVE}>{t('active')}</MenuItem>
                                                <MenuItem value={SUBADMIN.INACTIVE}>{t('inactive')}</MenuItem>
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3}>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("subadmin", "write"))) ?
                                                <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{subadminId ? t('submit') : t('Add')}</MDButton>
                                                :
                                                null
                                            }
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Subadmin;
